module.exports = __webpack_public_path__ + "img/icon_car.6d4b1af7.svg";